export default "__VITE_ASSET__d0343b3e__"